import { Component, OnInit } from '@angular/core';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditEnquiryComponent } from 'src/app/modules/pages/profile/edit-enquiry/edit-enquiry.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
})
export class SearchResultsComponent implements OnInit {
  authToken = localStorage.getItem('stoken');
  location: any = {};  // location as an object
  title: string = '';   // Initialize title as an empty string
  Searchresults: any[] = [];
  selectedIndustry: any = null;
  isToggled: boolean = false;
  payload: any = {}
  params: any = {};
  dialogRef: any;
  toastr: any;
  get Math() {
    return Math;
  }
  selectedSortOption: string = 'recent';
  industry: any[] = [];
  AllSubCategory1: any[] = [];
  AllSubCategory2: any[] = [];
  AllSubCategory3: any[] = [];
  AllBrandList: any[] = [];
  remainingCount: number = 0;
  totalCount: number = 0;
  pages: number[] = [];
  totalPages: number;
  isPaginationEnabled: boolean = false;
  currentPage: number = 1;
  selectedParams: any = {
    industryId: null,
    subCategory1Id: null,
    subCategory2Id: null,
    subCategory3Id: null,
    brand_id: null,
    job_type: null,
  };
  jobTypes: any[] = [{
    name: 'Job work seeker'
  },{
    name: 'Jobwork out source'
  }];
  job_work_id: any ='31dcdb22-05c4-4a27-8481-3afbee03e8d4';




  constructor(private router: Router, private service: ApiServicesService, private route: ActivatedRoute, private loader: NgxUiLoaderService, private dialog: MatDialog,
  ) {

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.location = params['location'] || '';
      this.title = params['title'] || '';
    });

    this.SearchProduct();
    this.resgetIndustry();
  }
 

  
  enquiry() {
    const screenWidth = window.innerWidth;
    let isSmallScreen = false;
    if (screenWidth <= 1440) {
      isSmallScreen = true;
    }
    let token = localStorage.getItem('stoken');
    if (token) {
      const dialogRef = this.dialog.open(EditEnquiryComponent, {
        maxHeight: '100vh',
        width: isSmallScreen ? '1000px' : '1000px',
        // data: {
        //   img: '../.assets/images/report.svg',
        //   heading: 'Enquiry',
        //   para: 'Lorem Ipsum is simply dummy text of the printing text of the printing. ',
        //   report: 'Yes, Logout',
        //   cancel: 'Cancel'
        //  }
      });
    }
    else {
      this.toastr.error('Need to login first');
      this.service.Login();
    }
  }


  toggle() {
    this.isToggled = !this.isToggled;
  }
  onSortChange() {
    switch (this.selectedSortOption) {
      case 'recent':
        this.params.sortType = this.selectedSortOption;
        this.fetchSearchData();
        break;
      case 'popularity':
        this.params.sortType = this.selectedSortOption;
        this.fetchSearchData();
        break;
      case 'ASC':
        this.params.sortType = this.selectedSortOption;
        this.fetchSearchData();
        break;
      case 'DESC':
        this.params.sortType = this.selectedSortOption;
        this.fetchSearchData();
        break;
    }
  }

  fetchSearchData() {
    window.scrollTo(0, 0);
    const params: any = {
      pageNo: this.currentPage,
      size: 20,
    };
    if (this.location) {
      this.payload.location = this.location;
    }
    if (this.title) {
      this.payload.title = this.title;
    }

    if (this.selectedSortOption) {
      params.sortType = this.selectedSortOption;
    }
    if (this.selectedParams.industryId) {
      params.industry_id = this.selectedParams.industryId;
    }
    if (this.selectedParams.subCategory1Id) {
      params.category1_id = this.selectedParams.subCategory1Id;
    }
    if (this.selectedParams.subCategory2Id) {
      params.category2_id = this.selectedParams.subCategory2Id;
    }
    if (this.selectedParams.subCategory3Id) {
      params.category3_id = this.selectedParams.subCategory3Id;
    }
    if (this.selectedParams.brand_id) {
      params.brand_id = this.selectedParams.brand_id;
    }
    if (this.selectedParams.job_type) {
      params.job_type = this.selectedParams.job_type;
    }

    const apiEndpoint = this.authToken ? API_ROUTES.SearchProduct1 : API_ROUTES.SearchProduct1WIthoutLogin;
    // Call API
    this.service.post(this.payload, apiEndpoint, params).subscribe({
      next: (response) => {
        if (response?.data?.products) {
          this.Searchresults = response?.data?.products;
          this.totalCount = response?.data?.totalCount || 0;
          this.remainingCount = response?.data?.remainingCount || 0;
          this.calculatePagination();
        } else {
          console.warn('No products found in the response.');
          this.Searchresults = [];
          this.totalCount = 0;
          this.remainingCount = 0;
          this.calculatePagination();
        }
      },
      error: (error) => {
        console.error('Error fetching search results:', error);
      },
    });

  }

  selectIndustry(industryId: any) {
    this.currentPage = 1;
    this.AllSubCategory2.length = 0;
    this.AllSubCategory3.length = 0;
    this.selectedParams.industryId = industryId;
    this.selectedParams.subCategory1Id = null;
    this.selectedParams.subCategory2Id = null;
    this.selectedParams.subCategory3Id = null;
    this.selectedParams.brand_id = null
    this.selectedParams.job_type = null
    this.getAllSubCategory1(industryId);
    this.fetchSearchData();
  }
  get selectedIndustryName(): string {
    const selectedIndustry = this.industry.find(industry => industry.id === this.selectedParams.industryId);
    return selectedIndustry ? selectedIndustry?.industry_name : this.title;
  }

  getAllSubCategory1(industryId: string): void {
    this.service.post({ industry_id: industryId }, API_ROUTES.Account.getIndustriesByCategorys, '').subscribe(
      (response) => {
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory1 = response.result.rows;
          this.AllBrandList = [];
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllSubCategory1 = [];
          this.AllBrandList = [];
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);
        this.AllSubCategory1 = [];
        this.loader.stop(); // Ensure the loader stops in case of an error
      }
    );
  }

  show_product(item: any): void {
    this.AllSubCategory3.length = 0;
    this.selectedParams.subCategory1Id = item.id;
    this.selectedParams.subCategory2Id = null;
    this.selectedParams.subCategory3Id = null;
    this.selectedParams.brand_id = null;
    this.selectedParams.job_type = null;

    // Fetch SubCategory2 based on SubCategory1
    this.getAllSubCategory2(item.id);
    this.getAllBrandList(item.id);
    this.fetchSearchData();
  }

  getAllSubCategory2(subCategory1Id: string) {
    this.service.post({ category1_id: subCategory1Id }, API_ROUTES.Account.getCatByCategory1, '').subscribe(
      (response) => {
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory2 = response.result.rows;
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllSubCategory2 = []; // Reset the array if no subcategories are found
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);
        this.AllSubCategory2 = [];
        this.loader.stop();
      }
    );
  }

  selectSubCategory2(item: any): void {
    this.selectedParams.subCategory2Id = item.id;
    this.selectedParams.subCategory3Id = null;
    // Fetch SubCategory3 based on SubCategory2
    this.getAllSubCategory3(item.id);
    this.fetchSearchData();
  }

  getAllBrandList(subCategory1Id: string) {
      this.service.get({ category1_id: subCategory1Id }, API_ROUTES.Account.getBrand, '').subscribe(
        (response) => {
          if (response?.result && response.result.length > 0) {
            this.AllBrandList = response.result;
            // if (this.selectedParams?.subCategory2Id) {
            //   this.getAllSubCategory3(this.selectedParams.subCategory2Id);
            // }
          } else {
            console.warn('No subcategories found for the selected industry.');
            this.AllBrandList = []; 
          }
        },
        (error) => {
          console.error('Error occurred while fetching subcategories:', error);
          this.AllBrandList = [];
          this.loader.stop();
        }
      );
    }
    selectBrands(item: any): void {
      this.selectedParams.brand_id = item.id;
      this.fetchSearchData();
    }
    selectJobType(item: any){
      this.selectedParams.job_type = item.name;
      this.fetchSearchData();
  
    }


  getAllSubCategory3(subCategory2Id: string) {
    this.service.post({ category2_id: subCategory2Id }, API_ROUTES.Account.getCatByCategory2, '').subscribe(
      (response) => {
        // console.log('Subcategories Response:', response);

        // Check if response contains subcategory data
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory3 = response.result.rows;
          // console.log('Subcategories loaded:', this.AllSubCategory3);
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllSubCategory3 = []; // Reset the array if no subcategories are found
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);

        // Reset subcategory array and handle the error
        this.AllSubCategory3 = [];
        this.loader.stop(); // Ensure the loader stops in case of an error
      }
    );

  }


  selectSubCategory3(item: any): void {
    this.selectedParams.subCategory3Id = item.id;
    this.fetchSearchData();
  }


  // industry: any;
  resgetIndustry() {
    this.service.get({}, `${API_ROUTES.Account.getIndustry}`).pipe().subscribe((res) => {
      // console.log('dsfsdfdsf', res.result);
      res.result.unshift({ 'id': 0, 'industry_name': 'All' });
      this.industry = res.result;
      // console.log('4444444444444444444', this.industry);
    })
  }

  industrysub: any;
  resgetIndustrySub() {
    this.service.get({}, `${API_ROUTES.MyRequirements.industryListSubCat}`).pipe().subscribe((res) => {
      // console.log('2222222222222', res.result);
      // res.result.unshift({ 'id': 0, 'industry_name': 'All' });
      this.industrysub = res.result;
      // console.log('ffffffffffsssss', this.industrysub);
    })
  }


  SearchProduct() {
    if (this.selectedParams.industryId === null) {
      this.selectedParams.industryId = 0;
    }
    const apiEndpoint = this.authToken ? API_ROUTES.SearchProduct1 : API_ROUTES.SearchProduct1WIthoutLogin;
    const params: any = {
      pageNo: this.currentPage,
      size: 20,
      sortType: this.selectedSortOption
    }
    // this.loader.start();
    if (!apiEndpoint) {
      console.error('API endpoint is undefined.');
      return;
    }
    const locationName = this.location?.name || this.location;
    // if (!this.title) {
    //   console.error('Title is required.');
    //   return;
    // }
    const payload: any = {
      title: this.title,
    };
    if (locationName) {
      payload.location = locationName;
    }

    // this.params = {
    //   pageNo: this.currentPage,
    //   size: 20,
    // };


    // Call API
    this.service.post(payload, apiEndpoint, params).subscribe({
      next: (response) => {
        // this.loader.stop();
        if (response?.data?.products) {
          this.Searchresults = response?.data?.products;
          this.totalCount = response?.data?.totalCount || 0;
          this.remainingCount = response?.data?.remainingCount || 0;
          // Calculate and update pagination
          this.calculatePagination();
          // console.log('Search Results:', this.Searchresults);
        } else {
          console.warn('No products found in the response.');
          this.Searchresults = [];
          this.totalCount = 0;
          this.remainingCount = 0;
          this.calculatePagination();
        }
      },
      error: (error) => {
        this.loader.stop();
        console.error('Error fetching search results:', error);
      },
    });
  }

  // filterProducts(industryID: any, name?: any) {
  //   const isChecked = this.selectedIndustries[name];
  //   if (isChecked) {
  //     if (!this.selectedIndustry1.includes(industryID)) {
  //       this.selectedIndustry1.push(industryID);
  //     }
  //   } else {
  //     const index = this.selectedIndustry1.indexOf(industryID);
  //     if (index > -1) {
  //       this.selectedIndustry1.splice(index, 1);
  //     }
  //   }
  //   this.fetchSearchData();
  //   // this.SearchProduct();
  // }

  viewSingleProduct(productId: string, category: string) {
    // if (category == 'Machine') {
    //   this.router.navigate([RouteConstant.machine], { queryParams: { productId: productId } });
    // } else if (category == 'Services') {
    //   this.router.navigate([RouteConstant.service], { queryParams: { productId: productId } });
    // } else if (category == 'Tools') {
    //   this.router.navigate([RouteConstant.tools], { queryParams: { productId: productId } });
    // } else if (category == 'Raw Material') {
    //   this.router.navigate([RouteConstant.rawmaterials], { queryParams: { productId: productId } });
    // }
    this.router.navigate([RouteConstant.productdetail], { queryParams: { productId: productId } });
  }
  numberOfProducts: number = 20;
  calculatePagination() {
    if (this.totalCount > 0 && this.numberOfProducts) {
      this.totalPages = Math.ceil(this.totalCount / this.numberOfProducts);
      // this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1); 
      this.isPaginationEnabled = this.totalPages > 1;
      this.updateDisplayedPages()
    } else {
      this.pages = [];
      this.isPaginationEnabled = false;
    }
  }
  rangeSize: any = 10
  updateDisplayedPages() {
    // const startPage = Math.floor((this.currentPage - 1) / this.rangeSize) * this.rangeSize + 1;
    // const endPage = Math.min(startPage + this.rangeSize - 1, this.totalPages);

    // this.pages = Array.from(
    //   { length: endPage - startPage + 1 },
    //   (_, i) => startPage + i
    // );
    const startPage = Math.max(1, this.currentPage - Math.floor(this.rangeSize / 2) + 1);
    const endPage = Math.min(this.totalPages, startPage + this.rangeSize - 1);
    const adjustedStartPage = Math.max(1, endPage - this.rangeSize + 1);
    this.pages = Array.from({ length: endPage - adjustedStartPage + 1 }, (_, i) => adjustedStartPage + i);
  }
  goToPage(page: number) {
    // if (page < 1 || page > this.totalPages) return;
    // this.currentPage = page;
    // this.updateDisplayedPages();
    // this.getProductsList();
    // this.fetchSearchData();
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    if (page < this.pages[0] || page > this.pages[this.pages.length - 1]) {
      this.updateDisplayedPages();
    }
    // this.updateDisplayedPages();
    this.fetchSearchData();
  }

  // Generate an array of page numbers
  generatePages() {
    this.pages = [];
    for (let i = 1; i <= this.currentPage; i++) {
      this.pages.push(i);
    }
  }

}
